import React from "react";

export const PurpleAlert = (props) => {
  return (
    <div className="fgaAlert purpleAlert">
      <h5 className="alert-heading">BİLGİNİZE</h5>
      <p>{props.content}</p>
    </div>
  );
};
